import { ApiClient } from '@bustickus/api';
import { IClientCountryBrief } from '@bustickus/models-client';
import { createApiAddress } from 'common/helpers';

class ApiCountries {
  private readonly client: ApiClient = ApiClient.getInstance();
  private static instance: ApiCountries | null = null;

  private constructor() {}

  static getInstance(): ApiCountries {
    if (ApiCountries.instance == null) {
      ApiCountries.instance = new ApiCountries();
    }

    return ApiCountries.instance;
  }

  async getAll(): Promise<IClientCountryBrief[]> {
    const address = createApiAddress('/client/countries');
    const response = await this.client.sendRequest<IClientCountryBrief[]>('get', address);
    return response;
  }
}

export default ApiCountries;
